import { useNavigate } from "hooks";
import React, { useEffect, useState } from "react";
import { Route, RouteProps } from "react-router-dom";

import { useDealUserRoleSelect, useUserRoleSelector } from "store";
import { NavigationSettings } from "hooks/shared-hooks/use-navigate";
import { IRoleName, RoutesKeys } from "store/types";

type RoleType = "account" | "deal";
interface Props extends Omit<RouteProps, "component"> {
  children: React.ReactNode;
  availableFor: IRoleName[];
  // redirectTo: RoutesKeys;
  redirectTo: NavigationSettings<RoutesKeys>;
  whichRole?: RoleType;
  enabled?: boolean;
}

export const ProtectedRoute: React.FC<Props> = ({
  children,
  availableFor,
  redirectTo,
  whichRole = "account",
  enabled = true,
  ...rest
}) => {
  const { name: accountRole } = useUserRoleSelector() || {};
  const dealRole = useDealUserRoleSelect();
  const [isContent, setIsContent] = useState<boolean>(false);
  const navigate = useNavigate();

  const roles: Record<RoleType, IRoleName | undefined | null> = {
    account: accountRole,
    deal: dealRole
  };

  useEffect(() => {
    const selectedRole = roles[whichRole];

    if (!selectedRole) return;

    if (enabled && availableFor.includes(selectedRole)) {
      setIsContent(true);
    } else {
      navigate(redirectTo);
    }
  }, []);

  if (!isContent) return null;

  return <Route {...rest}>{children}</Route>;
};
